// index.ts
import { installExtension } from "@juitnow/lib-fetch-client";
var ContentImpl = class {
  constructor(_http) {
    this._http = _http;
  }
  async getAsset(id, locale) {
    const result = await this._http.get(`/content/v1/assets/${id}`, {
      acceptStatuses: [404],
      parameters: { locale }
    });
    return result.status === 404 ? void 0 : result.data;
  }
  async getEntry(id, locale) {
    const result = await this._http.get(`/content/v1/entries/${id}`, {
      acceptStatuses: [404],
      parameters: { locale }
    });
    return result.status === 404 ? void 0 : result.data;
  }
  async findEntries(query = {}) {
    const { fields = {}, ...rest } = query;
    const parameters = {};
    Object.entries(rest).forEach(([key, value]) => parameters[key] = String(value));
    Object.entries(fields).forEach(([key, value]) => parameters[`fields.${key}`] = String(value));
    const result = await this._http.get("/content/v1/entries", { parameters });
    return result.data;
  }
  async all(locale) {
    const result = await this._http.get("/content/v1/all", { parameters: { locale } });
    return result.data;
  }
};
installExtension("content", ContentImpl);
//# sourceMappingURL=index.mjs.map
